import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Tooltip } from 'primeng/tooltip';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'p-chip' instead.
 */
@Component({
  selector: 'ag1-tag',
  templateUrl: './ag1-tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AngularSvgIconModule, Tooltip],
})
export class Ag1TagComponent {
  // Path to the icon to be used. Same syntax as specifying 'src' for svg-icon
  readonly iconPath = input<string>(undefined);
  // Text that will appear in more prominent text, next to the icon
  readonly mainText = input.required<string>();
  // Text that will appear less prominent, to the right of the main text
  readonly subText = input<string>(undefined);

  // Event emitted when closing the component
  readonly clickEvent = output<void>();

  inputValue: string = '';
  inputState: 'valid' | 'duplicate' | 'invalid' = 'valid';

  remove(): void {
    this.clickEvent.emit();
  }

  get colSpanClass(): string {
    const mainText: string = this.mainText();
    const subText: string = this.subText();

    if (this.iconPath() && mainText && subText) {
      return 'col-span-5';
    } else if (this.iconPath() && mainText && !subText) {
      return 'col-span-10';
    } else if (!this.iconPath() && mainText) {
      return 'col-span-11';
    }
    return ''; // default or fallback class
  }
}
